import { render, staticRenderFns } from "./RegisterOne.vue?vue&type=template&id=32dc3ec5&scoped=true&"
import script from "./RegisterOne.vue?vue&type=script&lang=ts&"
export * from "./RegisterOne.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dc3ec5",
  null
  
)

export default component.exports